export enum COUNTER_TYPE {
  SERVICES = 'services',
  NGOS = 'ngos',
}
